module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/disabled-borders.f27b20fb.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/disabled-borders.png
// module id = 2579
// module chunks = 11